import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useTheme } from '@/composables/useTheme'
import { queryPortalConfigReq } from '@/api/menu'

export const useAppStore = defineStore('app', () => {
  const { theme, initTheme, toggleTheme } = useTheme()
  const seoConfig = ref<Record<string, string>>({})

  const sidebarCollapsed = ref(false)

  function toggleSidebar(): void {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  function initApp(): void {
    initTheme()
  }

  async function initSeoConfig(): Promise<void> {
    const result = await queryPortalConfigReq('seo');
    const newConfig: Record<string, string> = {};
    result.data.result.configList.forEach(item => {
      newConfig[item.configKey] = item.configValue
    })
    seoConfig.value = newConfig
  }

  return {
    theme,
    sidebarCollapsed,
    seoConfig,
    toggleSidebar,
    toggleTheme,
    initApp,
    initSeoConfig
  }
})
